<section
  id="about"
  class="relative overflow-hidden py-24 px-6 lg:px-12"
  style="background: var(--theme-bg)"
  aria-label="About Aurrica"
  *transloco="let t"
>
  <div class="dot-accent-tr" aria-hidden="true"></div>

  <div class="max-w-7xl mx-auto">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

      <!-- Text column -->
      <div>
        <div class="section-label reveal">About Aurrica</div>
        <h2
          class="font-display font-bold mb-6 reveal stagger-1"
          style="font-size:clamp(1.875rem,4vw,3.125rem);letter-spacing:-0.025em;line-height:1.1"
        >
          Built for Africa,<br /><span class="gradient-text">Powered by Innovation</span>
        </h2>
        <p
          class="text-base lg:text-lg mb-8 reveal stagger-2"
          style="color:var(--theme-text-dim);line-height:1.8"
        >
          {{ t('aboutUs') }}
        </p>

        <!-- Tags -->
        <div class="flex flex-wrap gap-2 reveal stagger-3">
          @for (tag of aboutTags; track tag.label) {
            <span
              class="px-3 py-1.5 rounded-full text-xs font-semibold glass"
              [style.color]="tag.color"
              [style.border-color]="tag.borderColor"
            >
              {{ tag.label }}
            </span>
          }
        </div>
      </div>

      <!-- Africa SVG map -->
      <div class="h-72 lg:h-105 map-zoom-el">
        <app-africa-map></app-africa-map>
      </div>

    </div>
  </div>
</section>
